/*
 * 历史列表
 *
 * @Author: xiaoJQ
 * @Date: 2024-06-07 17:32:31
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import Table from 'components/common/table';
import positionStyles from 'components/position.less';
import { toYMDHMS } from 'components/util/util';
import { useSelector } from 'store/hook/useSelector';
import Styles from './index.less';
export var HistoryListData = {
    column: [
        {
            key: 'docName',
            isShow: true,
            title: '文档名称',
            froze: false,
            style: {
                minWidth: 80,
                maxWidth: 80,
                justifyContent: 'flex-start',
            },
            render: function renderBlock(data) {
                return (React.createElement("span", { title: data['docName'], key: "docName".concat(data.id) }, data['docName']));
            },
        },
        {
            key: 'planName',
            isShow: true,
            title: '方案名称',
            froze: false,
            style: {
                minWidth: 80,
                maxWidth: 80,
                justifyContent: 'flex-start',
            },
            render: function renderBlock(data) {
                return (React.createElement("span", { title: data['planName'], key: "planName".concat(data.id) }, data['planName']));
            },
        },
        {
            key: 'extractPages',
            isShow: true,
            title: '提取范围',
            froze: false,
            style: {
                minWidth: 150,
                maxWidth: 150,
                justifyContent: 'flex-start',
                overflow: 'hidden',
            },
            render: function renderBlock(data) {
                return (React.createElement("span", { title: data['extractPages'], key: "extractPages".concat(data.id) }, data['extractPages']));
            },
        },
        {
            key: 'createDate',
            isShow: true,
            title: '创建时间',
            froze: false,
            style: { minWidth: 150, maxWidth: 150, justifyContent: 'flex-start' },
            render: function renderBlock(data) {
                return (React.createElement("span", { title: toYMDHMS(data['createDate']), key: "createDate".concat(data.id) }, toYMDHMS(data['createDate'])));
            },
        },
        {
            key: 'endDate',
            isShow: true,
            title: '结束时间',
            froze: false,
            style: { minWidth: 150, maxWidth: 150, justifyContent: 'flex-start' },
            render: function renderBlock(data) {
                return (React.createElement("span", { title: toYMDHMS(data['endDate']), key: "endDate".concat(data.id) }, data['endDate'] === 0 ? '' : toYMDHMS(data['endDate'])));
            },
        },
        {
            key: 'status',
            isShow: true,
            title: '状态',
            froze: false,
            style: { minWidth: 80, maxWidth: 80, justifyContent: 'flex-start' },
            render: function renderBlock(data) {
                var _a, _b;
                var getHistoryStatusInfo = function (status) {
                    switch (status) {
                        case 'success':
                            return {
                                style: {
                                    color: '#26B175',
                                },
                                title: '提取完成',
                            };
                        case 'loading':
                            return {
                                style: {
                                    color: '#55A0F5',
                                },
                                title: '提取中',
                            };
                        case 'running':
                            return {
                                style: {
                                    color: '#55A0F5',
                                },
                                title: '提取中',
                            };
                        case 'error':
                            return {
                                style: {
                                    color: '#FB2323',
                                },
                                title: '提取失败',
                            };
                        case 'cancel':
                            return {
                                style: {
                                    color: '#FB2323',
                                },
                                title: '取消任务',
                            };
                        default:
                    }
                };
                return (React.createElement("span", { key: "status".concat(data.id), style: (_a = getHistoryStatusInfo(data.status)) === null || _a === void 0 ? void 0 : _a.style }, (_b = getHistoryStatusInfo(data.status)) === null || _b === void 0 ? void 0 : _b.title));
            },
        },
        {
            key: 'progress',
            isShow: true,
            title: '处理进度',
            froze: false,
            style: {
                minWidth: 80,
                maxWidth: 80,
                justifyContent: 'flex-start',
            },
            render: function renderBlock(data) {
                return (React.createElement("span", { title: data['progress'], key: "progress".concat(data.id) }, data['progress']));
            },
        },
        {
            key: 'creator',
            isShow: true,
            title: '申请人',
            froze: false,
            style: { minWidth: 80, maxWidth: 80, justifyContent: 'flex-start' },
            render: function renderBlock(data) {
                return (React.createElement("span", { title: data['creator'], key: "creator".concat(data.id) }, data['creator']));
            },
        },
        {
            key: 'totalPage',
            isShow: true,
            title: '总页数',
            froze: false,
            style: {
                minWidth: 80,
                maxWidth: 80,
                justifyContent: 'flex-start',
            },
            render: function renderBlock(data) {
                return (React.createElement("span", { title: data['totalPage'], key: "totalPage".concat(data.id) }, data['totalPage']));
            },
        },
    ],
};
var HistoryList = function () {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return state.global; }), model = _a.model, billId = _a.billId;
    var history = useSelector(function (state) { var _a; return (_a = state.data) === null || _a === void 0 ? void 0 : _a.history; });
    var _b = useState(null), historySelect = _b[0], setHistorySelect = _b[1];
    useEffect(function () {
        model === null || model === void 0 ? void 0 : model.invokeAsync('ie_history_task', billId);
    }, []);
    var getHistoricalDetail = function (data) {
        var _a;
        dispatch({
            type: 'changeDisplayPageFile',
            payload: {
                name: data.docName,
                type: (_a = data.docName) === null || _a === void 0 ? void 0 : _a.slice(data.docName.lastIndexOf('.') + 1).toLowerCase(),
            },
        });
        dispatch({
            type: 'showTask',
            payload: {
                data: {
                    status: 'loading',
                },
                control: { activeView: 'displaypage' },
            },
        });
        model === null || model === void 0 ? void 0 : model.invokeAsync('ie_show_task', data.id);
    };
    var deleteHistoricalDetail = function (id) {
        dispatch({ type: 'setDeleteHistoricalDetailId', payload: id });
        model === null || model === void 0 ? void 0 : model.invokeAsync('ie_delhistory_task', id);
    };
    var colunm = HistoryListData.column.concat([
        {
            key: 'operate',
            isShow: true,
            title: '操作',
            froze: true,
            style: { minWidth: 120, maxWidth: 164, justifyContent: 'flex-start' },
            render: function (data) {
                return (React.createElement("div", { key: "petitioner".concat(data.id), className: Styles.formOperating },
                    React.createElement("span", { onClick: function () {
                            getHistoricalDetail(data);
                        }, className: Styles.checkDetails, style: {
                            display: data.status !== 'cancel' ? 'block' : 'none',
                        } }, "\u67E5\u770B\u8BE6\u60C5"),
                    React.createElement("span", { onClick: function () {
                            dispatch({
                                type: 'showPopUp',
                                payload: {
                                    show: true,
                                    data: {
                                        title: '操作确认',
                                        msg: '删除后将不能查看此条比对结果，是否确认删除',
                                        onOk: function () {
                                            deleteHistoricalDetail(data.id);
                                            dispatch({
                                                type: 'hiddenPopUp',
                                                payload: 'hiddenPopUp',
                                            });
                                        },
                                        onCancel: function () {
                                            return dispatch({
                                                type: 'hiddenPopUp',
                                                payload: 'hiddenPopUp',
                                            });
                                        },
                                    },
                                },
                            });
                        }, style: { marginLeft: data.status !== 'cancel' ? 10 : 0 }, className: Styles.deleteDetail }, "\u522A\u9664"),
                    React.createElement("span", { onClick: function () {
                            model.invokeAsync('cancelExtract', {
                                taskId: '',
                                fid: data.id,
                            });
                            // model?.invokeAsync("ie_history_task", billId)
                        }, style: {
                            display: data.status === 'loading' || data.status === 'running'
                                ? 'block'
                                : 'none',
                            marginLeft: 10,
                        }, className: Styles.deleteDetail }, "\u53D6\u6D88\u4EFB\u52A1")));
            },
        },
    ]);
    return (React.createElement("div", { className: classNames(Styles.HistoryList, positionStyles.inTheMiddle) },
        React.createElement(Table, { key: 'historicalComparison', column: colunm, dataSource: history.historyList, onSelect: setHistorySelect, selectItem: historySelect })));
};
export default HistoryList;
